// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"34c41e36","208":"b3e7cb94","236":"1fc29247","353":"a3b5870f","512":"dc165db3","549":"b12f0369","813":"59849c13"}[chunkId] + ".chunk.js";
};